module.exports = __webpack_public_path__ + "static/media/wireframe_yeutech-ipad.5c17a922.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/wireframe_yeutech-ipad.png
// module id = 69
// module chunks = 0